import ApiResource from "../../Lib/ApiResource";

export default class ShareResource extends ApiResource {


    show(userId, shareToken) {
        return this.get('share/'+userId+'/'+shareToken);
    }

}
